<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">舆情收藏</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="标题" prop="Title">
            <el-input v-model="Title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Keywords"
                label="关键词"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="FirstWebContentSite"
                label="来源"
                width="100"
              ></el-table-column>
              <el-table-column prop="Title" label="标题" show-overflow-tooltip></el-table-column>
              <el-table-column label="属性" prop="State" width="80">
                <template slot-scope="scope">
                  <span class="iconGood" v-if="scope.row.State == 1"
                    ><span>正</span></span
                  >
                  <span class="iconBad" v-else><span>负</span></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionCollect",
  controller: "UI",
  action: "OpinionCollect",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      Title: "",
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "舆情收藏查询";
    this.logInfo.LogMessage = "舆情收藏查询";
    this.logInfo.ModuleName = "舆情监测";
    this.logInfo.PageName = "舆情收藏列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let that = this;
      let search = {
        Title: this.Title,
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
      };
      new MyApis.ContentCollectApi()
        .GetContentCollect(search)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd");
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.Title = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
